import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  message?: string;
  className?: string;
}

export function EmptyState({ message, className }: EmptyStateProps) {
  const { t } = useTranslation();
  const defaultMessage = t("emptyNoChildren");
  const displayMessage = message ?? defaultMessage;
  return (
    <div
      className={cn("text-center py-12 text-foreground/40", className)}
      role="status"
      aria-label={displayMessage}
    >
      <svg
        className="w-12 h-12 mx-auto mb-3 opacity-40"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p className="text-sm">{displayMessage}</p>
    </div>
  );
}
